<template>
  <v-app>
    <dialog-line-user-id-mapping-incomplete :opening="isLineUserIdMappingIncomplete"></dialog-line-user-id-mapping-incomplete>

    <v-main class="mb-12">
      <v-row class="pa-12 pb-1 mt-md-14 mt-2" justify="center">
        <v-img
          :src="`${cdnUrl}/assets/images/regist/welcome_illust2502.svg`"
          :max-width="$vuetify.breakpoint.mdAndUp ? 224 : 184"
          alt="会員登録が完了しました！"
        />
      </v-row>

      <template v-if="isEarningPointCompleted || isEarningPointScheduled">
        <v-row justify="center" class="text-md-subtitle-1 text-caption mx-auto mt-5 mb-0 text-center">
          お買い物に使えるポイント500円分を進呈しました！
        </v-row>
        <v-row justify="center" class="text-md-subtitle-1 text-caption mx-auto px-4 text-center align-baseline" style="white-space:nowrap;"
          :class="innerWidth > 350 ? 'flex-nowrap' : 'flex-wrap'"
        >
          マイページで確認できます
          <span style="font-size:80%;">（反映に時間がかかる場合があります）</span>
        </v-row>
      </template>


      <template v-if="isEarningPointCompleted || isEarningPointScheduled">
        <v-row justify="center" class="py-6 mb-12">
          <v-card flat to="/" width="320" height="52" max-width="90%" class="rounded white--text d-flex flex-column align-center justify-center" color="#2c2c2c">
            <p class="font-weight-bold text-body-1 mb-0">本をお探しの方はこちらから</p>
            <p class="text-caption mb-0">トップページへ</p>
          </v-card>
        </v-row>
      </template>
      <template v-else>
        <v-row flat justify="center" class="align-center ma-auto my-12" style="background:#F7F5EB;width:762px;height:120px;max-width:100%;" :style="$vuetify.breakpoint.mdAndUp ? '' : 'height:180px;'">
          <v-col cols="12" md="6" class="d-flex justify-center pl-md-8">
            <v-card flat color="transparent" class="d-flex flex-column align-left justify-center">
              <v-card flat color="transparent" class="d-flex" width="fit-content">
                <v-img contain :src="`${cdnUrl}/assets/images/regist/shinkan.svg`" :width="$vuetify.breakpoint.mdAndUp ? 42 : 37" :height="$vuetify.breakpoint.mdAndUp ? 27 : 18" alt="新刊"/>
                <v-img contain :src="`${cdnUrl}/assets/images/regist/chuuko.svg`" :width="$vuetify.breakpoint.mdAndUp ? 42 : 37" :height="$vuetify.breakpoint.mdAndUp ? 27 : 18" alt="中古"/>
              </v-card>
              <v-card-title class="pa-0 font-weight-bold text-md-h6 text-body-1">欲しい本、すぐ見つかる </v-card-title>
              <v-card-text class="pa-0" style="color:#009098;font-size:10px;">VBだけのオリジナル&コラボ商品もチェック！</v-card-text>
            </v-card>
            <v-card flat color="transparent" class="pl-md-5">
              <v-img :src="`${cdnUrl}/assets/images/regist/to_top__icon.png`" width="80" height="80" alt="本を探す人"/>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="pr-md-8">
            <v-card flat to="/" width="320" height="52" class="mx-auto rounded white--text d-flex flex-column align-center justify-center" color="#009098">
              <p class="font-weight-bold text-body-1 mb-0">本をお探しの方はこちらから</p>
              <p class="text-caption mb-0">トップページへ</p>
            </v-card>
          </v-col>
        </v-row>
      </template>

      <v-container v-if="couponCodeForMailSubscriber" class="px-0">
        <v-row justify="center" class="text-md-body-1 text-caption text-center font-weight-bold mx-2 px-4 px-md-0" style="white-space:nowrap;">
          ▼ ニュースレター購読でスペシャルクーポンプレゼント！▼
        </v-row>
        <v-row justify="center" class="ma-0 mt-5">
          <v-card flat @click="copyToClipboard()">
            <v-img
              contain
              :src="welcomeIllustrationUrl"
              max-width="640px"
              content-class="d-flex flex-column justify-center align-center"
            >
            </v-img>
          </v-card>
        </v-row>
        <v-row justify="center" class="text-caption mt-8 mb-md-3 mb-10 mx-2">
          <v-card flat class="d-flex align-center justify-center px-4" style="background:#E7760D;max-width:100%;" width="800" :height="$vuetify.breakpoint.mdAndUp ? 53 : 66">
            <v-icon dense left color="white">mdi-alert</v-icon>
              <p class="white--text font-weight-bold ma-0">このページを離れるとクーポンコードは表示できません。スクリーンショットやメモで保存してください。</p>
          </v-card>
        </v-row>
      </v-container>

      <coupon-benefit-label :isRegisterComplete="this.isRegisterComplete" :isRegisterCompleteNewsLetter="this.isRegisterCompleteNewsLetter"></coupon-benefit-label>

      <v-container class="px-0" :class="$vuetify.breakpoint.mdAndUp ? 'fixed-width' : ''">
        <validation-observer ref="observer" v-slot="observerProps">
          <items-remaining :show="((observerProps.touched && observerProps.invalid) || (isBackFromConfirmation && observerProps.invalid)) && isIntersecting"
                          :numberOfRemaining="countInvalidFields(observerProps.fields)"
          />
          <register-form
            :section-title3="null"
            :maxNumberOfPackages="maxPackagesNum"
            v-intersect="onIntersect"
          >
            <template #buybackCode>
              <vb-buyback-code
                :form-items-setter="setBuyFormItems"
                :form-items-getter="{buybackCode: getBuyFormItems.buybackCode}"
              />
            </template>
            <template #identityHint>
              古物営業法に基づき、本人確認手続きが必要です。<br/>
              お申込み後、マイページの身分証登録からアップロードしてください。
            </template>
            <template #identityAnnotation>
              ご利用できる身分証は<a class="accent--text text-decoration-underline" href="/sell/faq#faq-id-card" target="_blank">こちら</a>
            </template>

            <template #terms-of-service>
              <vb-terms-of-service
                :form-items-setter="setMemberFormItems"
                :form-items-getter="{isAgreedWithTermsAndPrivacy: getMemberFormItems.isAgreedWithTermsAndPrivacy}"
              />
            </template>

            <template #non-invoice-consent>
              <vb-non-invoice-consent
                  :form-items-setter="setMemberFormItems"
                  :form-items-getter="{nonInvoiceConsent: getMemberFormItems.nonInvoiceConsent}"
              >
              </vb-non-invoice-consent>
            </template>

            <template #button>
              <v-row justify="center" class="pt-4">
                <v-btn
                  class="secondary white--text text-subtitle-1 text-md-h6 text-md-h6"
                  :width="$vuetify.breakpoint.mdAndUp ? '500px' : '328px'"
                  :height="$vuetify.breakpoint.mdAndUp ? '76px' : '48px'"
                  :disabled="observerProps.invalid"
                  @click="goToConfirm"
                >
                  内容を確認する
                </v-btn>
              </v-row>
            </template>
          </register-form>
        </validation-observer>
      </v-container>


      <v-snackbar
        v-model="snackbar"
        :timeout="2000"
        min-width="216px"
        height="60px"
        right
        rounded="pill"
        elevation="0"
        color="primary"
        content-class="snackbar-content"
      >
        <v-row class="justify-center">
          <v-icon dense small left color="white">mdi-check-circle</v-icon>
          コピーしました
        </v-row>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import ItemsRemaining from "../../molecules/items-remaining.vue";
import VbPassword from "../../molecules/form/vb-password.vue";
import VbTermsOfService from "../../molecules/form/agreed/vb-terms-of-service.vue";
import VbBuybackCode from "../../molecules/form/vb-buyback-code.vue";
import CouponBenefitLabel from "../../molecules/buy/coupon-benefit-label.vue"
import VbNonInvoiceConsent from "../../molecules/form/agreed/vb-non-invoice-consent.vue";
import DialogLineUserIdMappingIncomplete from "../../organisms/dialog-line-user-id-mapping-incomplete.vue";
import RegisterForm from "../../template/register-form.vue";

export default {
  name: "registration-completed",
  components: {
    DialogLineUserIdMappingIncomplete,
    VbBuybackCode,
    VbNonInvoiceConsent,
    VbPassword,
    VbTermsOfService,
    RegisterForm,
    ItemsRemaining,
    CouponBenefitLabel,
  },
  data() {
    return {
      snackbar: false,
      welcomeIllustrationUrl: VueConfig.cdn_url + '/assets/images/regist/registration_coupon.png',
      cdnUrl: VueConfig.cdn_url,
      isIntersecting: false,
      maxPackagesNum :VueConfig.sell.maxNumberOfPackages,
      innerWidth: window.innerWidth,
    };
  },
  created() {
    this.setBuyFormItems({name: 'site_code', value: this.$siteCode});
    this.setMemberFormItems({name: 'email', value: this.emailAddress});
    this.setPickupTimeOffset(null);
  },
  props: {
    emailAddress: {
      type: String,
      default: null,
      required: true,
    },
    isEarningPointCompleted: {
      type: Boolean,
      default: false,
    },
    isEarningPointScheduled: {
      type: Boolean,
      default: false,
    },
    couponCodeForMailSubscriber: {
      type: String,
      default: null,
      required: false,
    },
    isLineUserIdMappingIncomplete: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      getBuyFormItems: 'buy/getFormItems',
      getBuyFormLabels: 'buy/getFormLabels',
      getMemberFormItems: 'member/getFormItems',
    }),
    countInvalidFields: function () {
      return function (fields) {
        let count = 0;
        for (let key of Object.keys(fields)) {
          !fields[key].valid && count++
        }
        return count;
      }
    },
    sheetRoundStyle() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return ''
        case 'sm':
          return ''
        case 'md':
          return 'rounded-lg'
        case 'lg':
          return 'rounded-lg'
        case 'xl':
          return 'rounded-lg'
      }
    },
    isBackFromConfirmation() {
      return this.$route.params.isBackButton;
    },
    isRegisterComplete () {
      return true;
    },
    isRegisterCompleteNewsLetter () {
      if(!(this.isEarningPointCompleted || this.isEarningPointScheduled)) {
        return '/assets/images/regist/buy_in_3min_msg.png';
      }
    },
  },
  methods: {
    ...mapActions({
      setMemberFormItems: 'member/updateFormItems',
      setBuyFormItems: 'buy/updateFormItems',
      setBuyFormLabels: 'buy/updateFormLabels',
      isValidatePickupTime: 'buy/isValidatePickupTime',
      retrieveCouponCode: 'buy/retrieveCouponCode',
    }),
    ...mapMutations({
      setPickupTimeOffset: 'buy/setPickupTimeOffset',
    }),
    copyToClipboard() {
      navigator.clipboard.writeText(this.couponCodeForMailSubscriber).then(
        () => {
          this.snackbar = true
        },
        (e) => {
          console.error(e)
        },
      );
    },
    async goToConfirm() {

      //クーポンチェック
      const result_coupon = await this.retrieveCouponCode();
      if (!result_coupon.status) {
        this.observerErrorHandle("クーポンコード", result_coupon.errorMsg);
        return
      }

      //集荷日チェック
      this.setPickupTimeOffset(null);
      const response_pickup_date = await this.isValidatePickupTime()
      if (!response_pickup_date) {
        this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
        return
      }

      this.$router.push({name: "BuyConfirm"});
    },
    observeSetErrors(name, errorMessage) {
      let params = {};
      params[name] = errorMessage;
      this.$refs.observer.setErrors(params);
    },
    scrollBehavior(position) {
      this.$vuetify.goTo(position, {
        duration: 300,
        offset: window.innerHeight / 2,
        easing: 'easeInOutCubic'
      })
    },
    scrollTargetNode(name) {
      return this.$refs.observer.refs[name].$el;
    },
    observerErrorHandle(name, message) {
      this.observeSetErrors(name, message);
      this.scrollBehavior(this.scrollTargetNode(name));
    },
    onIntersect (entries, observer) {
      this.isIntersecting = entries[0].isIntersecting
    },
    updateInnerWidth() {
      this.innerWidth = window.innerWidth;
    },
  },
  provide: function () {
    //子コンポーネントでエラーをセットするため
    return {
      setErrors: this.observeSetErrors
    }
  },
  mounted() {
    if (this.$route.params.validate_on_load) {
      this.$refs.observer.validate();
    }
    // 確認画面で集荷日時のエラーになった場合に表示する
    if (this.$route.params.pickup_date_error) {
      this.observerErrorHandle("日にち", "ご指定の集荷希望日は選択できません。");
    }
    window.addEventListener('resize', this.updateInnerWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateInnerWidth);
  },
}
</script>

<style scoped lang="scss">
.fixed-width {
  max-width: 1024px;
}

h1 {
  font-size: 30px;
  font-family: $hira_w1;
}

::v-deep {
  .row {
    &.email-subscription {
      display: none;
    }
  }

  #checkbox-multilines {
    height: 0;
  }

  .v-snack__wrapper {
    margin: 20px;
    border: solid 2px white;
  }

  .v-snack-transition-enter-to {
    transition-duration: .1s;
  }

  .v-snack-transition-leave-to {
    transition-duration: 1s;
  }

  .v-text-field__details {
    padding: 4px 0 0 !important;
  }
}
</style>